import React, { useEffect } from "react";
import { Redirect, useHistory } from "react-router-dom";
import "./Styles/UserDashboard.scss";

const UserDashboard = ({ certificatePool, profileCode, profile }) => {
  const history = useHistory();

  const roteChange = (cert) => {
    history.push({
      pathname: "/certificateDetails",
      state: { cert: cert, admin: false, profile: profile["email"] },
    });
  };
  if (localStorage.getItem("token") === null) {
    return <Redirect to="/" />;
  }
  if (profileCode === true) {
    localStorage.removeItem("token");
    return <Redirect to="/" />;
  }

  return (
    <div className="user-dashboard">
      <p className="title">Dashboard</p>
      <div className="containers">
        {certificatePool.map((certificate) => (
          <div key={certificate["eventID"]} className="container">
            <p>
              {" "}
              <b>Event name:</b> {certificate["eventName"]}
            </p>
            <p>
              <b> Description :</b> {certificate["description"]}
            </p>
            <p>
              {" "}
              <b>Speaker Name :</b> {certificate["speakerName"]}
            </p>
            <p>
              <b>Event Date :</b> {certificate["eventDate"]}
            </p>

            <p>
              <b>Published By :</b> {certificate["publishedBy"]["name"]}
            </p>

            {certificate["rejected"] ? (
              <p>
                <b>Status</b> : Rejected
              </p>
            ) : (
              <p>
                <b>Status</b> :{" "}
                {certificate["verified"] ? "Verified" : "Pending"}
              </p>
            )}

            <p>
              <b>Total Certificates :</b> {certificate["certificates"].length}
            </p>

            <p
              onClick={() => {
                roteChange(certificate);
              }}
              style={{ cursor: "pointer" }}
            >
              <b style={{ color: "blue" }}>Click here for Certificates List</b>
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserDashboard;
